module.exports = __webpack_public_path__ + "images/bancontact-80c19ec09416158d986841ab65d56de7.svg";